// Routes config
export const getCurrentService = (currentPath) => {
  const servicesUrls = [
    '/workload',
    '/network',
    '/application',
    '/filestorage',
    '/container',
    '/conformity',
    '/snyk',
    '/management',
    '/administration',
    '/integrations',
    '/my-user',
    '/audit',
    '/billing',
    '/mfe-template',
    '/support',
    '/reporting',
    '/assessments',
    '/update-account',
    '/cloud-one-central',
  ];
  return servicesUrls.find((service) => currentPath.indexOf(service) === 0);
};

// TODO: Remove the FeatureFlag check with C1C-11968
const checkGovCloudRegion = () => {
  const isGovCloudDeploymentTarget = ['govcloud-prod', 'govcloud-staging'].includes(
    process.env.DEPLOYMENT_TARGET
  );
  const hasGovCloudFeatureFlag = JSON.parse(
    localStorage.getItem('C1C_GOV_CLOUD_ENABLED') || 'false'
  );
  return isGovCloudDeploymentTarget || hasGovCloudFeatureFlag;
};
export const isGovCloudRegion = checkGovCloudRegion();

const deploymentTarget = isGovCloudRegion ? 'govcloud' : process.env.DEPLOYMENT_TARGET;

export const getNonServiceRoute = (currentPath) => {
  const nonServiceRoutes = [
    '/home',
    '/create-account',
    '/account-selection',
    '/template',
    '/onboarding',
  ];
  return nonServiceRoutes.find((route) => currentPath.indexOf(route) === 0);
};

export const checkGovCloudRedirect = (currentPath) => {
  const [basePath] = currentPath.split('/').filter(Boolean);
  // ignore if the path is /home or /
  if (basePath === 'home') return;

  const govCloudServices = [
    'workload',
    'management',
    'administration',
    'integrations',
    'my-user',
    'audit',
    'billing',
    'support',
    'update-account',
  ];

  if (!govCloudServices.includes(basePath)) {
    return window.history.pushState({}, '', '/home');
  }
};

export const isServiceEnabledForTargetEnv = (service, serviceState) => {
  // snyk is added separately to keep it last in the list so ignoring here
  if (service.id === 'snyk') {
    return false;
  }
  /* indicates which services to show in service dropdown
   * currently not using this for common services so ignoring adding services like subscriptions, projects etc.
   * 'sentry' is for CAM, 'central' is separate service
   */
  const defaultSecurityServices = [
    'workload',
    'network',
    'application',
    'filestorage',
    'container',
    'conformity',
  ];

  const servicesEnabledOnAlpha = [...defaultSecurityServices];
  const servicesEnabledOnStaging = [...defaultSecurityServices];
  const servicesEnabledOnProd = [...defaultSecurityServices];
  const servicesEnabledGovCloud = ['workload'];

  // to enable service based on the state (like general-availability, trial etc.)
  const hasCorrectState = serviceState ? serviceState === service.state : true;

  // TODO Update to use DEPLOYMENT_TARGET === 'govcloud-staging' || DEPLOYMENT_TARGET === 'govcloud-prod' - values tbd
  if (isGovCloudRegion) {
    return servicesEnabledGovCloud.find((enabledService) => enabledService === service.id);
  }

  // TODO: Update the deployment target here C1C-11968
  return (
    {
      alpha: servicesEnabledOnAlpha.find((enabledService) => enabledService === service.id),
      dev: servicesEnabledOnAlpha.find((enabledService) => enabledService === service.id),
      stage: servicesEnabledOnStaging.find((enabledService) => enabledService === service.id),
      prod: servicesEnabledOnProd.find((enabledService) => enabledService === service.id),
      govcloud: servicesEnabledGovCloud.find((enabledService) => enabledService === service.id),
    }[deploymentTarget] && hasCorrectState
  );
};
